import React, {MutableRefObject} from "react";
import Dialog from "@Features/dialog/components/Dialog";
import Button from "@Generic/buttons/Button";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {isNotEmpty} from "@Array/isNotEmpty";

interface NoTicketErrorModalProps {
    dialogRef: MutableRefObject<HTMLDialogElement>,
    closeModal: () => void,
    title: string,
    message: string,
    btnText: string,
    isInlineHtml: boolean,
}

function GenericCheckOrderErrorModal(props: NoTicketErrorModalProps) {
    const {
        dialogRef,
        closeModal,
        title,
        message,
        btnText,
        isInlineHtml,
    } = props

    const bckUpTitle = useTranslation("sys.there_has_been_an_error")
    const bckUpMessage = "An unexpected error occurred"
    const bckUpBtnText = "OK"

    return (
        <Dialog dialogRef={dialogRef}>
            <h4>
                {title ?? bckUpTitle}
            </h4>
            {isInlineHtml && isNotEmpty(message) ? (
                <p
                    dangerouslySetInnerHTML={{__html: (`${message}`)}}
                />
            ) : (
                <p>
                    {message ?? bckUpMessage}
                </p>
            )}
            <Button onClick={closeModal} className="green">
                {btnText ?? bckUpBtnText}
            </Button>
        </Dialog>
    )
}

export default GenericCheckOrderErrorModal